import {environment} from '../environment'
import axios from 'axios';
import { useBasicAuth } from '../../shared/components/auth/withBasicAuth';

const urlAPI = environment.getApi('geometryShapeTerrasIndigenas');

export const check = () => useBasicAuth.checkToken();

export const findAllGeometryShapeTerrasIndigenas = () => 
  axios.get(urlAPI + "/all/" , environment.HEADER)
  .then(({data}) => data)
  .catch(e => {
    useBasicAuth.handleError(e);
  });

export const findAllGeometryShapeTerrasIndigenasInsideByCidade = (id) => 
  axios.get(urlAPI + "/byCidade/inside/" + id, environment.HEADER)
  .then(({data}) => data)
  .catch(e => {
    useBasicAuth.handleError(e);
  });

export const findAllGeometryShapeTerrasIndigenasIntersectsByCidade = (id) => 
  axios.get(urlAPI + "/byCidade/intersects/" + id, environment.HEADER)
  .then(({data}) => data)
  .catch(e => {
    useBasicAuth.handleError(e);
  });

export const findAllGeometryShapeTerrasIndigenasInsideByEstado = (id) => 
  axios.get(urlAPI + "/byEstado/inside/" + id, environment.HEADER)
  .then(({data}) => data)
  .catch(e => {
    useBasicAuth.handleError(e);
  });

export const findAllGeometryShapeTerrasIndigenasIntersectsByEstado = (id) => 
  axios.get(urlAPI + "/byEstado/intersects/" + id, environment.HEADER)
  .then(({data}) => data)
  .catch(e => {
    useBasicAuth.handleError(e);
  });

